
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Lightbulb } from "lucide-react";
import { inspirationQuotes } from "./inspirationQuotes";

const DailyQuote = () => {
  const [currentQuote, setCurrentQuote] = useState(() => {
    const randomIndex = Math.floor(Math.random() * inspirationQuotes.length);
    return inspirationQuotes[randomIndex];
  });
  
  const getNewQuote = () => {
    let randomIndex;
    do {
      randomIndex = Math.floor(Math.random() * inspirationQuotes.length);
    } while (inspirationQuotes[randomIndex].quote === currentQuote.quote);
    
    setCurrentQuote(inspirationQuotes[randomIndex]);
  };
  
  return (
    <div className="bg-muted/50 rounded-lg p-4 border">
      <div className="flex items-start mb-3">
        <Lightbulb className="h-5 w-5 mr-2 text-amber-500 flex-shrink-0 mt-0.5" />
        <h3 className="font-medium">Daily Inspiration</h3>
      </div>
      
      <blockquote className="italic text-muted-foreground ml-7 mb-3 relative">
        <span className="text-3xl font-serif absolute -left-5 -top-2 text-muted-foreground/30">"</span>
        {currentQuote.quote}
      </blockquote>
      
      <div className="flex justify-between items-center ml-7">
        <span className="text-sm">— {currentQuote.author}</span>
        <Button 
          variant="ghost" 
          size="sm" 
          onClick={getNewQuote}
          className="text-xs"
        >
          New Quote
        </Button>
      </div>
    </div>
  );
};

export default DailyQuote;
